import React, { useState, useRef, useEffect } from 'react';
import './downloadChart.scss';
import { ReactComponent as VerticalDots } from '../../../images/dots-vertical.svg';
import { ProtectAction } from '../../../rbac';

interface DownloadChartProps {
  onClick: (option: string) => void;
  canExportPdf?: boolean;
  canExportJpg?: boolean;
}

const predefinedOptions = ['Download as PDF', 'Download as JPG'];

const DownloadChart: React.FC<DownloadChartProps> = ({ onClick, canExportPdf, canExportJpg }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (option: string) => {
    onClick(option);
    setIsOpen(false);
  };

  return (
    <div className='download-chart-dropdown' ref={dropdownRef}>
      <div className='card-header-icon' onClick={() => setIsOpen(!isOpen)}>
        <VerticalDots className='dots-icon' />
      </div>
      {isOpen && (
        <div className='download-chart-dropdown-menu'>
          {predefinedOptions.map((option, index) => (
            <ProtectAction canAccess={
              (canExportPdf && option === 'Download as PDF') ||
              (canExportJpg && option === 'Download as JPG')
            }>
              <div key={index} className='download-chart-dropdown-item' onClick={() => handleSelect(option)}>
                {option}
              </div>
            </ProtectAction>
          ))}
        </div>
      )}
    </div>
  );
};

export default DownloadChart;
